import { KeyboardEvent } from 'react';
import Icon from './Icon';
import styles from './Input.module.css';

export type InputProps = {
  label?: string;
  valor: string;
  onChange: (valor: string) => void;
  tipo?: string;
  icone?: string;
  placeholder?: string;
  erro?: string;
  dica?: string;
  obrigatorio?: boolean;
  autoFocus?: boolean;
  onEnter?: () => void;
};

export default function Input({
  label,
  valor,
  onChange,
  tipo = 'text',
  icone,
  placeholder,
  erro,
  dica,
  obrigatorio,
  autoFocus,
  onEnter
}: InputProps) {
  const aoTeclar = (evento: KeyboardEvent<HTMLInputElement>) => {
    if (evento.key === 'Enter') onEnter?.();
  };

  return (
    <label className={styles.raiz}>
      {label && (
        <span className={styles.rotulo}>
          {label}
          {obrigatorio && <span className={styles.asterisco}>*</span>}
        </span>
      )}
      <span className={`${styles.campo} ${erro ? styles.comErro : ''}`}>
        {icone && (
          <span className={styles.icone}>
            <Icon nome={icone} tamanho={18} />
          </span>
        )}
        <input
          className={styles.entrada}
          type={tipo}
          value={valor}
          onChange={(evento) => onChange(evento.target.value)}
          onKeyDown={aoTeclar}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      </span>
      {erro ? (
        <span className={styles.erro}>{erro}</span>
      ) : (
        dica && <span className={styles.dica}>{dica}</span>
      )}
    </label>
  );
}
